export default function ClickEffects() {
    // document.addEventListener("contextmenu", function(e){
    //     e.preventDefault();
    //   }, false);
    
    //   document.onkeydown = function(e) {
    //     if (e.keyCode == 123 || 
    //         (e.ctrlKey && e.shiftKey && (e.keyCode == 73 || e.keyCode == 74 || e.keyCode == 67)) || 
    //         (e.ctrlKey && e.keyCode == 85)) {
    //       return false;
    //     }
    //   };
}
  